import React from "react";
import { styled } from "../../stitches.config";
import { bodyLarge } from "../commonStyles/Fonts";

import { AttachmentElement } from "../../components/Article/Parts/Slate/types"

type AttachmentBaseProps = {
    element: AttachmentElement;
    icon: string;
};

const AttachmentContentBase: React.FC<AttachmentBaseProps> = ({
    element,
    icon
}) => {

    return (
        <StyledAttachment className={bodyLarge()}>
            <a href={element.data?.media?.media?.download_url} download>
                <img src={icon} />
                <span>{element.source ? element.source : "Pobierz plik"}</span>
            </a>
        </StyledAttachment>
    );
};

const StyledAttachment = styled("div", {
    background: "$primary",
    margin: "18px 0",

    "& img": {
        width: "32px",
        height: "32px",
        marginRight: "8px",
        marginLeft: "-40px",
    },

    "& a": {
        padding: "10px 16px",
        background: "$primary",
        color: "$grayscale0Fixed !important",
        widht: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },

    "& span": {
        display: "block",
        maxWidth: "200px",
        textAlign: "center",
        "@bp3": {
            maxWidth: "620px",
        },
        "@bp4": {
            maxWidth: "780px",
        }
    }
});

export default AttachmentContentBase;
